import { CSSProperties, useMemo } from 'react'
import { css, FlattenSimpleInterpolation } from 'styled-components'
import { TableColumn } from '../table.types'

function parsePxValue(value: string | number | undefined): number {
  if (typeof value === 'number') return value
  if (typeof value === 'string' && value.endsWith('px'))
    return parseFloat(value)
  return 0
}

export type ColumnStylesResult = {
  styles: FlattenSimpleInterpolation[]
  totalStickyWidth: number
}

export function useColumnStyles(columns: TableColumn[]): ColumnStylesResult {
  return useMemo(() => {
    const styles: FlattenSimpleInterpolation[] = []
    let cumulativeLeft = 0

    columns.forEach((col, index) => {
      const childIndex = index + 1

      if (col.isSticky) {
        const bgColor = col.bgColor || 'white'

        styles.push(css`
          & th:nth-child(${childIndex}),
          & td:nth-child(${childIndex}) {
            position: sticky;
            left: ${cumulativeLeft}px;
            background-color: ${bgColor};
          }

          & th:nth-child(${childIndex}) {
            z-index: 2;
          }

          & td:nth-child(${childIndex}) {
            z-index: 1;
          }
        `)

        const props = col.props as CSSProperties | undefined
        const width = parsePxValue(props?.minWidth ?? props?.width)
        cumulativeLeft += width
      } else if (col.bgColor) {
        styles.push(css`
          & td:nth-child(${childIndex}) {
            background-color: ${col.bgColor};
          }
        `)
      }
    })

    return { styles, totalStickyWidth: cumulativeLeft }
  }, [columns])
}
